import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = window.localStorage.getItem("hg_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401 && window.location.pathname !== "/admin") {
            window.localStorage.removeItem("hg_admin_token");
            window.location.assign("/admin");
        }
        return Promise.reject(err);
    }
);

export const fmtApiError = (e) => {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
    return e?.message || "Something went wrong";
};

export default api;
